export const REPORT_BACKGROUND_COLOR = {
  Attestation: '#efefef',
}

export const SPACES_FOLDER = {
  Attestation: 'attestation',
}
